import React, { useMemo, useCallback, useState } from "react";
import { CustomerGroups as CustomerGroupsApi } from '../../api/services/next';
import GridSearchTemplate from "../GridSearchTemplate";
import CheckboxWrapper from '../../components/shared/Checkbox';
import CheckBoxToggle from '../../components/shared/CheckBoxToggle';
import { useTextResources } from '../../language';
import IsActiveColumn from './grid/IsActiveColumn';
import ActionsColumn from './grid/ActionsColumn';
import AddCustomerGroupPopup from "./popups/AddCustomerGroupPopup";
import { useLoader } from '../../hooks/useLoader';
import { onError, onSuccess } from '../../components/shared/messages';

const CustomerGroups = () => {
    const text = useTextResources();
    const loader = useLoader();

    const [spec, setSpec] = useState([]);
    const [data, setData] = useState([]);

    const refreshData = useCallback(async () => {
      const newData = await CustomerGroupsApi.GetCustomerGroups(spec);
      setData(newData);
    }, [spec]);

    const handleSearchChange = useCallback((spec) => {
      setSpec(spec);
    }, []);

    const handleSearchComplete = useCallback((data) => {
      setData(data);
    }, []);

    const saveCustomerGroup = useCallback(async (customerGroupToSave) => {
      try {
          loader(true);
          await CustomerGroupsApi.CreateOrUpdateCustomerGroup(customerGroupToSave);
          await refreshData();
          onSuccess();
      } catch (error) {
          onError(error);
          throw error;
      } finally {
          loader(false);
      }
  }, [loader, refreshData]);

    const gridOptions = useMemo(() => ({
        search: {
          fields: [
            <CheckboxWrapper
              label={text('IncludeInactive')}
              key='InActive'
            />,
          ],
          api: CustomerGroupsApi.GetCustomerGroups,
          method: 'GET',
          searchOnLoad: true,
          initial: {        
            InActive: false,
          },
        },
        grid: {
          columns: [
            { name: 'Name', title: text('GroupName') },
            {
              name: 'IsActive',
              title: text('Active'),
              formatter: IsActiveColumn,
              customFilter: CheckBoxToggle,
            },
            {
              name: 'Actions',
              title: text('Actions'),
              formatter: ActionsColumn,
              saveCustomerGroup,
            },
          ],
          paging: true,
          filtering: {
            extensions: [
              { columnName: 'Actions', filteringEnabled: false },
            ],
            defaults: [
              { columnName: 'IsActive', value: true },
            ],
          },
          menu: [],
          cacheId: 'CustomerGroups',
          customOptions: {
            sort: {
              sorting: [
                { columnName: 'Name', direction: 'asc' },
              ],
            },
          },
          editable: {
            allowAdd: true,
            allowEdit: false,
            modalEditor: {
                modal: AddCustomerGroupPopup,
                props: {
                  saveCustomerGroup,
                }
            },
          },
        },
      }), [saveCustomerGroup, text]);

    return (
        <GridSearchTemplate
          options={gridOptions}
          onSearchChange={handleSearchChange}
          onSearchComplete={handleSearchComplete}
          data={data}
        />
    )
};

export default CustomerGroups;
